import enDefault from './en/default.json';
import enError from './en/error.json';
import esDefault from './es/default.json';
import esError from './es/error.json';

const resources = {
  en: {
    default: enDefault,
    error: enError,
  },
  es: {
    default: esDefault,
    error: esError,
  },
};

export default resources;
